const KEY_PREFIX = 'balancio_onboarding_';

export type OnboardingState = {
  checklistDismissed: boolean;
  namedBooks: boolean;
  addedEvent: boolean;
  sawList: boolean;
  firstRunTourDone: boolean;
};

const DEFAULT_STATE: OnboardingState = {
  checklistDismissed: false,
  namedBooks: false,
  addedEvent: false,
  sawList: false,
  firstRunTourDone: false,
};

function storageKey(userId?: number | string | null): string {
  return `${KEY_PREFIX}${userId || 'anon'}`;
}

export function isDemoSession(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem('is_demo_login') === 'true';
}

export function getOnboarding(userId?: number | string | null): OnboardingState {
  if (typeof window === 'undefined') return { ...DEFAULT_STATE };
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return { ...DEFAULT_STATE };
    return { ...DEFAULT_STATE, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_STATE };
  }
}

export const ONBOARDING_UPDATED_EVENT = 'balancio-onboarding-updated';

function emitOnboardingUpdated(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(ONBOARDING_UPDATED_EVENT));
}

export function setOnboarding(
  userId: number | string | null | undefined,
  partial: Partial<OnboardingState>
): OnboardingState {
  const next = { ...getOnboarding(userId), ...partial };
  if (typeof window !== 'undefined') {
    localStorage.setItem(storageKey(userId), JSON.stringify(next));
    emitOnboardingUpdated();
  }
  return next;
}

export function markOnboarding(
  userId: number | string | null | undefined,
  key: keyof OnboardingState
): OnboardingState {
  return setOnboarding(userId, { [key]: true });
}

export function isChecklistVisible(state: OnboardingState): boolean {
  if (state.checklistDismissed) return false;
  const complete = state.namedBooks && state.addedEvent && state.sawList;
  return !complete;
}

/** Signup used to auto-create books and then mark every step done. That fingerprint has no real events. */
export function looksLikeFalseComplete(state: OnboardingState): boolean {
  return (
    state.checklistDismissed &&
    state.namedBooks &&
    state.addedEvent &&
    state.sawList &&
    state.firstRunTourDone
  );
}

export const FROM_SETUP_KEY = 'balancio_from_setup';
export const FIRST_RUN_PATH = '/records?setup=1';
